import { Button, Col, Row, Spinner } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import { makeHomeBtns } from "../../config/home_config";
import { useEffect, useState } from "react";
import { axiosBaseURL } from "../../http";
import { toast } from "react-toastify";
import { BaseContainer } from "../../core/base_container";
import SessionStore from "../../lazyLoaders/session_lazy";

export const HomePage = () => {

    const navigate = useNavigate();
    const [btns, setBtns] = useState(null);

    useEffect(() => {
        const getFocusedKB = async () => {
            axiosBaseURL.get('knowledge_api/focused_knowledge_base/get_focused_kb/').then(function (response) {
                setBtns(makeHomeBtns({ kb_id: response.data?.id, chapter_id: SessionStore.getChapter() }))
            }).catch(function (error) {
               // toast.error('Failed to fetch focused KB')
                makeHomeBtns()
            });
        };
        getFocusedKB()
    }, []);

    return (
        <BaseContainer>
            {btns ? (
                <Col>
                    {
                        btns.filter(btn => btn.enabled === true).map((btn, index) => (
                            <Row style={{marginBottom:'2rem'}} key={index}>
                                <Col>
                                    <Button
                                        id={btn.id}
                                        className={btn.class}
                                        style={btn.style}
                                        onClick={() => navigate(btn.location)}
                                    >
                                        {btn.text}
                                    </Button>
                                </Col>
                            </Row>
                        ))
                    }
                </Col>
            ) : (
                <Row className="justify-content-center">
                    <Spinner size="lg" variant="primary" />
                </Row>
            )}
        </BaseContainer>
    )
}